import customHeaders, { getSpace } from '../../../../common/headers';
import { useState, useEffect } from 'react'
import { TitlePage } from '../../../TitlePage/TitlePage'
import { ButtonBasic, NoDataContent } from '@lk-gtcom/ecomlab-components';
import { useResponseHandler } from '../../../../common/auth';
import useGeneralStore from '../../../../store/general';
import { ButtonCopy } from '../../../Buttons/ButtonCopy/ButtonCopy';
import './ModalAddFileToken.scss'
import { TextPage } from '../../../TextPage/TextPage';
import { InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../ModalComponent/ModalComponent';

const ModalAddFileToken = ({
    setIsModal,
    selectedDirectory,
    setSelectedDirectory
}) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();

    const [numberMonth, setNumberMonth] = useState(1)
    const [selectedRole, setSelectedRole] = useState(null); // 'reader' или 'coAuthor'
    const [token, setToken] = useState(null)
    const [tokenList, setTokenList] = useState(null)

    const handleRadioChange = (role) => {
        setSelectedRole(role);
    };

    // Получение списка токенов
    const fetchGetTokenList = () => {
        let url = 'https://apps2.ecomru.ru:4460/api/v1/access-tokens'

        fetch(url, { headers })
            .then(handleTableResponse)
            .then((json) => setTokenList(json?.tokens))
            .catch(handleRequestError);
    };

    // Создание токена
    const fetchGetToken = () => {
        let url = 'https://apps2.ecomru.ru:4460/api/v1/access-tokens'

        const body = JSON.stringify({
            permissions: selectedRole,
            period_months: numberMonth,
            directory_id: selectedDirectory
        });

        fetch(url, { method: 'POST', headers, body })
            .then(handleTableResponse)
            .then((json) => {
                setToken(json?.token)
                setTimeout(() => fetchGetTokenList(), 100)
            })
            .catch(handleRequestError);
    };



    useEffect(() => {
        fetchGetTokenList()
    }, []);

    return (
        <ModalComponent
            title={`Создать токен для ID-${selectedDirectory}`}
            onClose={(e) => {
                setSelectedDirectory(null)
                setIsModal(false);
            }}
            style={{
                height: 'auto',
                maxWidth: '600px'
            }}
            child={
                <div className="modal-add-file-token">
                    <div className="modal-add-file-token__radio-group">
                        <label className="modal-add-file-token__radio-label">
                            <input
                                type="radio"
                                name="role"
                                className="modal-add-file-token__radio-input"
                                checked={selectedRole === 'read'}
                                onChange={() => handleRadioChange('read')}
                            />
                            <span className="modal-add-file-token__radio-text">Читатель</span>
                        </label>

                        <label className="modal-add-file-token__radio-label">
                            <input
                                type="radio"
                                name="role"
                                className="modal-add-file-token__radio-input"
                                checked={selectedRole === 'write'}
                                onChange={() => handleRadioChange('write')}
                            />
                            <span className="modal-add-file-token__radio-text">Соавтор</span>
                        </label>
                    </div>

                    <InputDinamycPlaceholder
                        changeValue={numberMonth}
                        onChange={setNumberMonth}
                        type='number'
                        size='s'
                        placeholder='Период месяцев'
                    />

                    {token &&
                        <div className='modal-add-file-token__token'>
                            <TextPage
                                text={token}
                            />
                            <ButtonCopy value={token} />
                        </div>
                    }

                    <div className="modal-add-file-token__btn-group">
                        <ButtonBasic
                            blue
                            width={'calc(50% - 6px)'}
                            text='Создать'
                            disabled={!selectedRole}
                            onClick={(e) => {
                                fetchGetToken()
                                // setSelectedDirectory(null)
                                // setIsModal(false)
                            }}
                        />

                        <ButtonBasic
                            grey
                            width={'calc(50% - 6px)'}
                            text='Отмена'
                            onClick={(e) => {
                                setSelectedDirectory(null)
                                setIsModal(false)
                            }}
                        />
                    </div>

                    <TitlePage
                        medium
                        title='Список токенов'
                    />

                    <div className="modal-add-file-token__tokens-list">
                        {tokenList && tokenList.length > 0 ? tokenList?.map(({ id, permissions, period_months, created_at, expires_at, directory_id }) => (
                            <div key={id} className="modal-add-file-token__token-item">
                                <div className="modal-add-file-token__token-info">
                                    <div className="modal-add-file-token__token-id">
                                        <strong>ID токена:</strong> {id}
                                    </div>
                                    <div className="modal-add-file-token__token-permissions">
                                        <strong>Права:</strong> {permissions === 'write' ? 'Соавтор' : 'Читатель'}
                                    </div>
                                    <div className="modal-add-file-token__token-period">
                                        <strong>Срок (мес.):</strong> {period_months}
                                    </div>
                                    <div className="modal-add-file-token__token-created">
                                        <strong>Создан:</strong> {new Date(created_at).toLocaleString()}
                                    </div>
                                    <div className="modal-add-file-token__token-expires">
                                        <strong>Истекает:</strong> {new Date(expires_at).toLocaleString()}
                                    </div>
                                    <div className="modal-add-file-token__token-directory">
                                        <strong>ID папки:</strong> {directory_id}
                                    </div>
                                </div>
                            </div>
                        ))
                            :
                            <NoDataContent
                                height='100%'
                                description={'Нет доступных токенов для удаления'}
                            />
                        }
                    </div>
                </div>
            }
        />
    )
}

export { ModalAddFileToken }